module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"MovingIT Parts & Accessories","short_name":"M-IT","start_url":"/","background_color":"#ffffff","theme_color":"#56cfe1","display":"minimal-ui","icon":"content/assets/movingit-icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"455d6eb964f74e513db8208d92d2b467"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
